// Map server-side ApiError codes from the /pay-card and /refund routes to
// user-friendly strings shown inline next to the Pay button. Unknown codes
// fall back to a passed-in default so we never expose a raw code or empty
// state to clients.

const FRIENDLY: Record<string, string> = {
  payment_provider_error:
    'Payment service is temporarily unavailable. Please try again in a few minutes.',
  kyc_required:
    'KYC verification must be completed before paying by card. Please contact your engagement lead.',
  currency_not_supported_by_card:
    'This invoice’s currency is not enabled for card payments. Please pay by bank transfer.',
  currency_unsupported:
    'This invoice’s currency is not enabled for card payments. Please pay by bank transfer.',
  too_many_attempts:
    'Too many payment attempts in the last few minutes. Please wait and try again.',
  not_payable:
    'This invoice can no longer be paid by card.',
  not_found:
    'This invoice is no longer available.',
  forbidden:
    'You do not have permission to pay this invoice.',
  invalid_amount:
    'This invoice has an invalid amount and cannot be paid by card.',
};

export function mapPaymentError(code: string | undefined, fallback: string): string {
  if (!code) return fallback;
  return FRIENDLY[code] ?? fallback;
}
